import { ErrorHandler, Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorAlertComponent } from "./error-alert/error-alert.component";
import { DocumentReference, Firestore, addDoc, collection, doc, serverTimestamp, updateDoc } from "@angular/fire/firestore";
import { AuthService } from '../services/auth.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {

  private dialog = inject(MatDialog);
  private fs = inject(Firestore);
  private authServ = inject(AuthService);

  handleError(error: any): void {
    console.error(error);
    
    let errorDocRef: DocumentReference;    
    try {
      const serialized = JSON.stringify(error, Object.getOwnPropertyNames(error));
      this.saveErrorLog(this.authServ.auth.user_id, JSON.parse(serialized))
        .then(result => {
          if (result) {
            errorDocRef = result;
          }
        })
    } catch (error) {
      console.error('Failed to serialize error object');      
    }
    // this.dialog.open(ErrorAlertComponent, {
    //   data: { message: error.message }
    // }).afterClosed().subscribe(userMessage => {
    //   if (userMessage && errorDocRef) {
    //     console.log(userMessage);
        
    //     updateDoc(errorDocRef, { _userMessage: userMessage }).catch(console.error);
    //   }
    // });
  }

  private saveErrorLog(user: string, trace: Object) {
    return addDoc(collection(this.fs, 'errorLogs'), {
      createdTimestamp: serverTimestamp(),
      user, ...trace
    }).catch(console.error);
  }

}